@if (task?.priority) {
    <app-task-priority-widget [priority]="task.priority" size="small" />
}

